import { render } from "./RanksRecord.vue?vue&type=template&id=5a26266e&scoped=true"
import script from "./RanksRecord.vue?vue&type=script&lang=js"
export * from "./RanksRecord.vue?vue&type=script&lang=js"

import "./RanksRecord.vue?vue&type=style&index=0&id=5a26266e&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a26266e"]])

export default __exports__